
import React, { createContext, useState, useEffect } from 'react';
import { LocalStorageService } from './services'
import socketio from "socket.io-client";


const defaultState = {
    setShowError: () => { }
};

//Socket Context 
export const socket = socketio.connect(process.env.REACT_APP_MIFIRMA_API_SOCKET);
export const SocketContext = React.createContext();

export const Context = createContext(defaultState);

export const ContextProvider = (props) => {
    const [showSignatureCanvas, setShowSignatureCanvas] = useState(false)
    const [showPdf, setShowPdf] = useState(false)
    const [pdf, setPdf] = useState(null)
    const [pdfSucess, setPdfSucess] = useState(null)
    const [canvasData, setCanvasData] = useState({})
    const [clientLogo, setclientLogo] = useState()

    const [notificationFilters, setNotificationFilters] = useState({
        selectedFilter: 'Pendientes',
    })

    useEffect(() => {
        let localStorageService = new LocalStorageService()
        if (props.logo) {
            setclientLogo(props.logo)
            localStorageService.setLocalStorageItem('clientLogo', props.logo)
        } else {
            let logo = localStorageService.getLocalStorageItem('clientLogo')
            if (logo) {
                setclientLogo(logo)
            } else setclientLogo('')
        }
    }, [props.logo])

    const updateNotificationFilter = (newFilterState) => {
        setNotificationFilters(prev => ({
            ...prev,
            ...newFilterState
        }))
    }

    const setSelectedFilter = (filter) => {
        setNotificationFilters(prev => ({
            ...prev,
            selectedFilter: filter
        }))
    }

    const params = {
        pdfSucess, setPdfSucess,
        visibleDialogTimerSignOff: props.visibleDialogTimerSignOff,
        setShowError: props.setShowError,
        showSignatureCanvas,
        setShowSignatureCanvas,
        canvasData,
        setCanvasData,
        showPdf,
        setShowPdf,
        pdf,
        setPdf,
        clientLogo,
        setclientLogo,
        notificationFilters,
        updateNotificationFilter,
        setSelectedFilter,
    }
    return (
        <Context.Provider value={params} >
            {props.children(params)}
        </Context.Provider>
    )
};